import {Form, Formik} from 'formik'
import {Fragment, useEffect, useState} from 'react'
import * as Yup from 'yup'

import Logo from '../../../_metronic/assets/logo.png'

import StartedForm from '../components/Form2-Corporate'
import StartedFormProvider from '../components/Form2-Provider'
// import PaymentInfo from '../components/Payment'

import {useIntl} from 'react-intl'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import getCountries from 'src/feature/become-merchant/services/getCountries'
import {regexDomain} from 'src/feature/bite/helpers/webSiteRegex'
import submitForm from '../services/submitForm'
import './style.css'

export default function MerchantForm2() {
  const intl = useIntl()
  const router = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const type = searchParams.get('type')

  const [list] = useState<{countries: any[]; cities: any[]; regions: any[]}>({
    countries: [],
    cities: [],
    regions: [],
  })

  useEffect(() => {
    getCountries().then((res) => {
      list.countries = res
    })
  }, [list])

  const errorTranslate = intl.formatMessage({id: 'AUTH.BECOME_MEMBER.ERROR'})
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (values: any) => {
    setIsLoading(true)
    const {check, phone} = values
    const countries = list.countries
    const countryCode = countries.find((item) => item.exCode === values.countryCode)?.code

    let regex = new RegExp(`${countryCode.replace('+', '\\+')}|\\(|\\)|-|\\s`, 'g')
    let newPhone = phone.replace(regex, '').replace('+', '')

    if (!check) {
      toast.error(intl.formatMessage({id: 'AUTH.BECOME_MEMBER.ACCEPT'}), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })

      setIsLoading(false)
      return
    }

    if (type === 'freelancer') values.brandName = values.name + ' ' + values.lastName
    if (type === 'freelancer') values.officialName = values.name + ' ' + values.lastName

    if (type === 'corporate') values.brandName = values.officialName

    const response = await submitForm({
      ...values,
      phone: newPhone,
      countryCode: countryCode,
    })

    if (response.status) {
      setTimeout(() => {
        router('/become-a-merchant/pricing?merchantID=' + response.merchantID)
      }, 1000)
    } else {
      toast.error(response.message || errorTranslate, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
    }

    setIsLoading(false)
  }

  const validSchemaMerchant = Yup.object().shape({
    brandName: Yup.string().optional().nullable(),
    officialName: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    categoryIDs: Yup.array()
      .of(Yup.string())
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    subCategoryIDs: Yup.array()
      .of(Yup.string())
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    webSite: Yup.string()
      .matches(regexDomain, intl.formatMessage({id: 'GLOBAL.VALIDATION.WEBSITE'}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    title: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    name: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
    lastName: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
    email: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    phone: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .when(['countryCode'], ([countryCode], schema) => {
        if (countryCode === 'AE') {
          const regex = /^\+9715\d{8}$/
          return schema.matches(regex, intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE'}))
        } else {
          return schema.matches(
            /^\+?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
            intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE_GENERAL'})
          )
        }
      }),
    cityID: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    aptBuildingNo: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    address: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    check: Yup.boolean().oneOf(
      [true],
      intl.formatMessage({id: 'GLOBAL.VALIDATION.AGREEMENT_REQUIRED'})
    ),
  })

  const validSchemaFreelancer = Yup.object().shape({
    partnerTypeID: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    categoryIDs: Yup.array()
      .of(Yup.string())
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    subCategoryIDs: Yup.array()
      .of(Yup.string())
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    name: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
    lastName: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
    webSite: Yup.string().matches(
      regexDomain,
      intl.formatMessage({id: 'GLOBAL.VALIDATION.WEBSITE'})
    ),
    email: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    /*     phone: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .matches(/^[^\_]+$/, intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE'})), */
    phone: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .when(['countryCode'], ([countryCode], schema) => {
        if (countryCode === 'AE') {
          const regex = /^\+9715\d{8}$/
          return schema.matches(regex, intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE'}))
        } else {
          return schema.matches(
            /^\+?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
            intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE_GENERAL'})
          )
        }
      }),
    cityID: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    aptBuildingNo: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    address: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    check: Yup.boolean().oneOf(
      [true],
      intl.formatMessage({id: 'GLOBAL.VALIDATION.AGREEMENT_REQUIRED'})
    ),
  })

  const initialValuesMerchant = {
    businessType: 1,
    merchantName: '',
    merchantEmail: '',
    isoName: '',
    isoid: '',
    updateDateAndTime: '',
    name: '',
    surname: '',
    email: '',
    phone: '',
    countryCode: 'AE',
    check: false,
    title: '',
    brandName: '',
    officialName: '',
    webSite: '',
    countryID: 'f109e594-b301-ec11-a85d-000d3a229408',
    categoryIDs: [],
    subCategoryIDs: [],
    lastName: '',
    cityID: '',
    aptBuildingNo: '',
    language: '',
    address: '',
  }

  const initialValuesFreelancer = {
    businessType: 2,
    partnerTypeID: '',
    categoryIDs: [],
    subCategoryIDs: [],
    name: '',
    lastName: '',
    email: '',
    phone: '',
    countryCode: 'AE',
    countryID: 'f109e594-b301-ec11-a85d-000d3a229408',
    cityID: '',
    aptBuildingNo: '',
    address: '',
    check: false,
  }

  return (
    <Fragment>
      {false ? (
        <></>
      ) : (
        <>
          <div
            className='d-flex flex-column flex-root px-10 justify-content-center background-gradient'
            id='kt_app_root'
          >
            <div className='flex-column flex-column-fluid' id='kt_app_page'>
              <div className='d-flex flex-column gap-10'>
                <div
                  className='container-fluid pt-8'
                  id='kt_app_header_container'
                  style={{
                    zIndex: 1000,
                  }}
                >
                  <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                    <a href='/sign-in'>
                      <img alt='Logo' src={Logo} style={{width: 150}} />
                    </a>
                  </div>

                  <div className='mt-10'>
                    <a
                      href='/become-a-merchant/merchant-form'
                      className='d-flex align-items-center gap-3'
                    >
                      <i className='bi bi-chevron-left fs-4 text-black'></i>
                      <span className='text-black fs-3 fw-bold'>Back</span>
                    </a>
                  </div>
                </div>

                <div className='d-flex justify-content-center align-items-center'>
                  <div className='w-100'>
                    {type === 'corporate' ? (
                      <Formik
                        enableReinitialize
                        initialValues={initialValuesMerchant}
                        validationSchema={validSchemaMerchant}
                        onSubmit={onSubmit}
                      >
                        {({errors, touched, values, setFieldValue, setTouched, handleSubmit}) => (
                          <Form>
                            <div className='d-flex justify-content-center align-items-center mt-2 gap-10 w-100'>
                              <StartedForm
                                errors={errors}
                                touched={touched}
                                setTouched={setTouched}
                                list={list}
                                values={values}
                                setFieldValue={setFieldValue}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                handleSubmit={handleSubmit}
                              />
                            </div>
                          </Form>
                        )}
                      </Formik>
                    ) : (
                      <Formik
                        enableReinitialize
                        initialValues={initialValuesFreelancer}
                        validationSchema={validSchemaFreelancer}
                        onSubmit={onSubmit}
                      >
                        {({errors, touched, values, setFieldValue, setTouched, handleSubmit}) => (
                          <Form>
                            <div className='d-flex justify-content-start align-items-start mt-2 gap-10'>
                              <StartedFormProvider
                                errors={errors}
                                touched={touched}
                                setTouched={setTouched}
                                list={list}
                                values={values}
                                setFieldValue={setFieldValue}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                handleSubmit={handleSubmit}
                              />
                            </div>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  )
}
